import mixpanel from 'mixpanel-browser'
import * as Sentry from '@sentry/vue'

const AHABIGQ_INSTANCE_NAME = 'ahabigq'

let instance = null
let active = false

const MAX_PENDING_IDENTITY_CALLS = 20
const pendingIdentityCalls = []

const resolveInstance = (initResult) => initResult || mixpanel[AHABIGQ_INSTANCE_NAME] || null

const PERSONAL_PROPERTY_KEYS = ['$email', '$first_name', '$last_name', '$name', '$phone']

const syncSuperProperties = (target) => {
  const props = { ...mixpanel.persistence?.properties?.() }
  PERSONAL_PROPERTY_KEYS.forEach((key) => delete props[key])
  // register() merges, so a user id Mixpanel dropped while mirroring was off would otherwise stay on later anonymous events
  Object.keys(target.persistence?.properties?.() || {}).forEach((key) => {
    if (!(key in props)) target.unregister(key)
  })
  if (Object.keys(props).length) target.register(props)
}

const replayPendingIdentityCalls = (target) => {
  pendingIdentityCalls.splice(0).forEach((callback) => {
    try {
      callback(target)
    } catch {
      // AhaBigQ must never affect Mixpanel or the UI
    }
  })
}

const init = (url, projectToken, options = {}) => {
  if (!url || !projectToken) return
  if (instance) {
    instance.set_config({ disable_persistence: options.disable_persistence === true })
    syncSuperProperties(instance)
    active = true
    return
  }
  try {
    // mixpanel-js keys its cookie and batch queue by token, so a same-token instance would flush Mixpanel's queued events to AhaBigQ
    instance = resolveInstance(mixpanel.init(`${AHABIGQ_INSTANCE_NAME}_${projectToken}`, {
      ...options,
      api_host: url,
      record_sessions_percent: 0,
      persistence_name: AHABIGQ_INSTANCE_NAME,
      batch_requests: true,
      persistence: 'localStorage',
    }, AHABIGQ_INSTANCE_NAME))
    active = !!instance
    if (instance) {
      syncSuperProperties(instance)
      replayPendingIdentityCalls(instance)
    }
  } catch (error) {
    instance = null
    active = false
    Sentry.captureException(error)
  }
}

const mirror = (callback) => {
  if (!instance || !active) return
  try {
    callback(instance)
  } catch {
    // AhaBigQ must never affect Mixpanel or the UI
  }
}

const mirrorIdentity = (callback) => {
  if (!instance) {
    if (pendingIdentityCalls.length >= MAX_PENDING_IDENTITY_CALLS) pendingIdentityCalls.shift()
    pendingIdentityCalls.push(callback)
    return
  }
  mirror(callback)
}

const reset = () => {
  pendingIdentityCalls.length = 0
  mirror((bigQ) => {
    bigQ.reset()
    syncSuperProperties(bigQ)
  })
}

const stop = () => {
  active = false
}

export default {
  init,
  stop,
  mirror,
  mirrorIdentity,
  reset,
  isActive: () => active,
}
